/** Canonical month-count → human label, shared by the billing / cadence / meter interval selects. */
export const MONTH_INTERVAL_LABELS: Record<number, string> = {
  1: 'Monthly',
  2: 'Bi monthly',
  3: 'Quarterly',
  6: 'Every 6 months',
  12: 'Yearly',
};

export function getMonthIntervalLabel(months: number): string {
  return MONTH_INTERVAL_LABELS[months] ?? '';
}
